import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_839fb698: FaireBrandEntity = {
  token: "b_839fb698",
  type: "brand",
  name: "Daydream Prints",
  avatarUrl:
    "https://cdn.faire.com/fastly/8ea1807004d8d3294cd6364abc794da3c9b99f50c8a43bcc5febac8e9bab3df1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/60834cdda06426447d65640d6d4c5c2b4994df04268b1a8c5094261595956c50.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8ea1807004d8d3294cd6364abc794da3c9b99f50c8a43bcc5febac8e9bab3df1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/60834cdda06426447d65640d6d4c5c2b4994df04268b1a8c5094261595956c50.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 315,
  isTopShop: true,
  isInsider: true,
  description:
    "🌊 𝗖𝗼𝗮𝘀𝘁𝗮𝗹 𝘀𝗽𝗶𝗿𝗶𝘁, 𝗽𝗹𝗮𝘆𝗳𝘂𝗹 𝗱𝗲𝘀𝗶𝗴𝗻\nDaydream Prints is a women-owned stationery and lifestyle brand offering wholesale greeting cards and stickers with a retro, surf-inspired aesthetic. Our colorful, cheeky designs bring personality and fun to every display, making them perfect for gift shops, coastal boutiques, and clothing stores.\n\n🌱 𝗘𝗰𝗼-𝗳𝗿𝗶𝗲𝗻𝗱𝗹𝘆 + 𝘀𝘂𝘀𝘁𝗮𝗶𝗻𝗮𝗯𝗹𝗲\nAll greeting cards are printed on FSC approved paper, paired with recycled kraft envelopes, and packaged in plastic-free, plant-based sleeves. Stickers are high-quality and designed to last. We also donate $2 from every wholesale order to the Surfrider Foundation to help protect our oceans and beaches.\n\n✨ 𝗥𝗲𝘁𝗮𝗶𝗹𝗲𝗿 𝗳𝗼𝗰𝘂𝘀𝗲𝗱\nBestselling greeting cards and stickers designed to move quickly, boost add-on sales, and keep customers coming back. Easy to merchandise & reorders ship fast.\n\nPlease note: we do not offer exclusivity, but reach out if you’d like to check coverage in your area.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:08.344Z",
    importedBy: "entity-db-cli",
  },
};
